export const API_ENDPOINTS = {
  LOGIN: '/v1/auth/login',
  LOGIN_VERIFY_CODE: '/v1/auth/login/verify-code',
  PASSWORD_RESET_REQUEST: '/v1/auth/password/reset/request',
  PASSWORD_RESET_CONFIRM: '/v1/auth/password/reset/confirm',
  REGISTER: '/v1/auth/register',
  REFRESH: '/v1/auth/refresh',
  TELEGRAM: '/v1/auth/telegram',
  ME: '/v1/me',
  ACCOUNT_DELETION_REQUEST: '/v1/me/account-deletion-request',
  DIRECTIONS: '/directions',
  QUESTIONS: '/questions',
  ADMIN: '/admin',
  USERS_SEARCH: '/v1/users/search',
  USERS_ROLE: '/v1/users',
  SUBSCRIPTION_TYPES: '/v1/subscription-types',
  ONBOARDING_SOURCE: '/v1/me/onboarding/source',
  ADMIN_ONBOARDING_STATS: '/admin/onboarding-stats',
  DESKTOP_DOWNLOAD: '/v1/downloads/desktop',
};

const inferDefaultBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  if (typeof window !== 'undefined') {
    const { hostname, port } = window.location;

    if (hostname === 'localhost' && port === '3200') {
      return '/api';
    }

    if (hostname === 'localhost') {
      return 'http://localhost:8081/api';
    }
  }
  return '/api';
};

export const PATH = inferDefaultBaseUrl();
export const BACKEND_ORIGIN = PATH.replace('/api', '');
